<template>
  <div
    class="shadow-hard-sm relative flex flex-nowrap gap-x-2 rounded-lg border-2 border-black-dark p-3"
    :class="colorClasses"
  >
    <div
      v-if="dismissable"
      class="absolute right-2 top-4 h-5 w-5"
      @click="$emit('dismiss')"
    >
      <XIcon class="h-full w-full" />
    </div>

    <component :is="icon" class="mt-0.5 h-5 w-5 shrink-0"> </component>
    <div class="flex-1" :class="dismissable ? 'mr-4' : ''">
      <p v-if="information" class="text-sm">{{ information }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {
  XIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  ExclamationIcon,
  CheckCircleIcon,
} from "@heroicons/vue/solid";

export default {
  name: "InformationText",
  components: {
    XIcon,
  },
  props: {
    dismissable: {
      type: Boolean,
      default: false,
    },
    information: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "teal",
    },
    solid: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["dismiss"],
  computed: {
    colorClasses() {
      if (this.solid) {
        switch (this.color) {
          case "teal":
            return "bg-teal text-white shadow-teal-hard-sm dark:bg-teal dark:text-white";
          case "red":
            return "bg-kekkle-red text-white shadow-red-hard-sm dark:bg-kekkle-red dark:text-white";
          case "green":
            return "bg-green-600 text-white shadow-green-hard-sm dark:bg-green-600 dark:text-white";
          case "orange":
            return "bg-orange text-white shadow-orange-hard-sm dark:bg-orange dark:text-white";
          case "blue":
            return "bg-kekkle-blue text-kekkle-dark shadow-blue-hard-sm dark:bg-kekkle-blue dark:text-kekkle-dark";
          case "yellow":
            return "bg-kekkle-yellow text-kekkle-dark shadow-yellow-hard-sm dark:bg-kekkle-yellow dark:text-kekkle-dark";
          default:
            return "bg-white text-kekkle-dark dark:bg-kekkle-dark-light dark:text-slate-200";
        }
      }

      switch (this.color) {
        case "teal":
          return "bg-teal-super-light text-teal-dark shadow-teal-hard-sm dark:bg-teal/40 dark:text-teal-light";
        case "red":
          return "bg-kekkle-red/20 text-gray-800 shadow-red-hard-sm dark:bg-kekkle-red/30 dark:text-slate-200";
        case "green":
          return "bg-green-100 text-green-700 shadow-green-hard-sm dark:bg-green-900/30 dark:text-green-300";
        case "orange":
          return "bg-orange/20 text-gray-800 shadow-orange-hard-sm dark:bg-orange/30 dark:text-slate-200";
        case "blue":
          return "bg-kekkle-blue/20 text-gray-800 shadow-blue-hard-sm dark:bg-kekkle-blue/60 dark:text-slate-200";
        case "yellow":
          return "bg-kekkle-yellow/30 text-gray-800 shadow-yellow-hard-sm dark:bg-kekkle-yellow/80 dark:text-gray-900";
        default:
          return "";
      }
    },
    icon() {
      switch (this.color) {
        case "teal":
          return InformationCircleIcon;
        case "red":
          return ExclamationCircleIcon;
        case "green":
          return CheckCircleIcon;
        case "orange":
          return ExclamationIcon;
        case "blue":
          return InformationCircleIcon;
        case "yellow":
          return InformationCircleIcon;
        default:
          return "";
      }
    },
  },
};
</script>
